var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6837 33.817L30.5003 27.6837C32.9005 24.691 34.0628 20.8925 33.7483 17.0692C33.4339 13.2458 31.6664 9.6883 28.8095 7.12807C25.9526 4.56784 22.2233 3.19951 18.3885 3.30445C14.5537 3.40938 10.9049 4.9796 8.19223 7.69223C5.4796 10.4049 3.90938 14.0537 3.80445 17.8885C3.69951 21.7233 5.06784 25.4526 7.62807 28.3095C10.1883 31.1664 13.7458 32.9339 17.5692 33.2483C21.3925 33.5628 25.191 32.4005 28.1837 30.0003L34.317 36.1337C34.4719 36.2899 34.6563 36.4139 34.8594 36.4985C35.0625 36.5831 35.2803 36.6267 35.5003 36.6267C35.7203 36.6267 35.9382 36.5831 36.1413 36.4985C36.3444 36.4139 36.5287 36.2899 36.6837 36.1337C36.9841 35.8229 37.152 35.4076 37.152 34.9753C37.152 34.5431 36.9841 34.1278 36.6837 33.817ZM18.8337 30.0003C16.5262 30.0003 14.2706 29.3161 12.352 28.0341C10.4334 26.7522 8.93809 24.9301 8.05507 22.7983C7.17204 20.6665 6.94101 18.3207 7.39117 16.0576C7.84133 13.7945 8.95247 11.7157 10.5841 10.0841C12.2157 8.45247 14.2945 7.34133 16.5576 6.89117C18.8207 6.44101 21.1665 6.67205 23.2983 7.55507C25.4301 8.43809 27.2522 9.93344 28.5341 11.852C29.8161 13.7706 30.5003 16.0262 30.5003 18.3337C30.5003 21.4279 29.2712 24.3953 27.0832 26.5832C24.8953 28.7712 21.9279 30.0003 18.8337 30.0003Z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch40);
export default __webpack_public_path__ + "static/media/search-40.f4ac2b380fa5716ab86ce9e71c929724.svg";
export { ForwardRef as ReactComponent };